import { Component } from "react";
import "./admissions.css";

class Admissions extends Component {
  handleSubmit = async (event) => {
    event.preventDefault();
  };

  render() {
    return (
      <>
        <div id="admission" className="admission-ultimate-container">
          <h2 className="admission-header">Admissions Open for 2026-27</h2>
          <p className="admission-description">
            Join Saraswathi Pathashala and embark on a journey of academic
            excellence and holistic development.
          </p>
          <div className="admission-demo-containers">
            <div className="admission-container">
              <h4 style={{ marginBottom: "0px" }}>Admission Process</h4>
              <ul>
                <li className="admin-process">
                  <span className="process-steps">1</span>
                  <div>
                    <h5 className="adminprocess-head">Initial Inquiry</h5>
                    <p className="adminprocess-text">
                      Contact us through phone, email, or visit our center to
                      inquire about available batches and timings.
                    </p>
                  </div>
                </li>
                <li className="admin-process">
                  <span className="process-steps">2</span>
                  <div>
                    <h5 className="adminprocess-head">Diagnostic Assessment</h5>
                    <p className="adminprocess-text">
                      A simple assessment to understand the student’s current
                      knowledge level and learning needs.
                    </p>
                  </div>
                </li>
                <li className="admin-process">
                  <span className="process-steps">3</span>
                  <div>
                    <h5 className="adminprocess-head">Counseling Sessions</h5>
                    <p className="adminprocess-text">
                      Discussion with parents and students about goals,
                      expectations, and recommended courses.
                    </p>
                  </div>
                </li>
                <li className="admin-process">
                  <span className="process-steps">4</span>
                  <div>
                    <h5 className="adminprocess-head">
                      Registration & Fee Payment
                    </h5>
                    <p className="adminprocess-text">
                      Complete the registration form and pay the applicable fees
                      to secure admission.
                    </p>
                  </div>
                </li>
              </ul>
              <h4 className="admin-fee-structure">Fee Structure</h4>
              <p className="admin-fee-strucuture-text">
                Our fee structure varies based on class, subjects, and batch
                type. Please contact us for detailed information
              </p>
            </div>
            <div className="book-demo-container">
              <h4>Book A Free Demo Class</h4>
              <p className="book-demo-description">
                Experience our teaching methodology firsthand. Fill the form
                below to schedule a free demo class.
              </p>
              <form className="form-container" onSubmit={this.handleSubmit}>
                <div className="form-elements">
                  <label htmlFor="studentName" className="form-label">
                    Student Name
                  </label>
                  <input
                    placeholder="Enter Student Name"
                    id="studentName"
                    className="form-input"
                    type="text"
                  />
                </div>
                <div className="form-elements">
                  <label htmlFor="parentName" className="form-label">
                    Parent Name
                  </label>
                  <input
                    placeholder="Enter Parent Name"
                    id="parentName"
                    className="form-input"
                    type="text"
                  />
                </div>
                <div className="form-elements">
                  <label htmlFor="phone" className="form-label">
                    Phone No.
                  </label>
                  <input
                    placeholder="Enter Phone No."
                    id="phone"
                    className="form-input"
                    type="text"
                  />
                </div>
                <div className="form-elements">
                  <label htmlFor="mail" className="form-label">
                    Email Address
                  </label>
                  <input
                    placeholder="Enter Email Address"
                    id="mail"
                    className="form-input"
                    type="text"
                  />
                </div>
                <div className="form-elements">
                  <label htmlFor="class" className="form-label">
                    Current Class
                  </label>
                  <select name="class" id="class" className="select-input">
                    <option value="" disabled selected hidden>
                      Select Class
                    </option>
                    <option value="class6">Class 6</option>
                    <option value="class7">Class 7</option>
                    <option value="class8">Class 8</option>
                    <option value="class9">Class 9</option>
                    <option value="class10">Class 10</option>
                  </select>
                </div>
                <div className="form-elements">
                  <label htmlFor="subject" className="form-label">
                    Select Subject
                  </label>
                  <select name="subject" id="subject" className="select-input">
                    <option value="" disabled selected hidden>
                      Select Subject
                    </option>
                    <option value="English">English</option>
                    <option value="Mathematics">Mathematics</option>
                    <option value="Science">Science</option>
                    <option value="SocialStudies">Social Studies</option>
                  </select>{" "}
                </div>
                <div className="form-addInfo">
                  <label htmlFor="addInfo" className="form-label">
                    Additional Information
                  </label>
                  <br />
                  <textarea
                    placeholder="Any specific requirements or questions"
                    className="text-area"
                  />
                </div>
                <div>
                  <input type="checkbox" id="agreement" />
                  <label htmlFor="agreement" className="agreement-label">
                    I agree to receive communication about Saraswathi Pathashala
                    Services
                  </label>
                </div>

                <button type="submit" className="book-demo-class-button">
                  <a href="tel:+919876543210" style={{ color: "white" }}>
                    Book Demo Class
                  </a>
                </button>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Admissions;
